<div class="h5p-timer">
  <mat-icon [ngClass]="{'warning-icon': minutes === 0 && seconds > 0}">alarm</mat-icon>
  <div class="timer" [ngClass]="{'warning-timer': minutes === 0 && seconds > 0}">{{ minutes | number: '2.0-0' }}:{{ seconds | number: '2.0-0' }}</div>
</div>
